<script setup>
import { onMounted } from 'vue';
import { useCloseKeyboard } from '@/composables/useCloseKeyboard'
import { useRequestsStore } from '@/stores/storeRequests';
import { useSettingsStore } from '@/stores/storeSettings';
import { useScrollStore } from '@/stores/storeScroll';
import { useLangStore } from '@/stores/storeLang';
import AppNav from '@/components/layout/AppNav.vue';
import BaseLoader from '@/components/layout/BaseLoader.vue';
import TheModals from '@/components/layout/TheModals.vue';
import TheStockStatusPage from '@/pages/TheStockStatusPage.vue';
import WebApp from '@twa-dev/sdk'

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();

useCloseKeyboard()

onMounted(async () => {
	WebApp.expand()
    await storeRequests.fetchProfile();

    // Синхронизируем язык профиля на бэке с языком клиента (UI) — иначе серверные
    // тексты (описание приза после спина) придут на языке профиля, а не UI
    const clientLang = useLangStore().lang;
    if (storeRequests.userData?.language && storeRequests.userData.language !== clientLang) {
        await storeRequests.updateLanguage(clientLang);
    }

    await storeSettings.mainSettings();

    const onAppResume = async () => {
        // Язык не откатываем на bot_lang — сохраняем выбор пользователя (pepsi_lang)
        await storeRequests.refreshProfile();
        await storeSettings.mainSettings();
    };

    const onHide = () => { storeRequests.profileLoaded = false; };

    WebApp.onEvent('activated', onAppResume);

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') onHide();
        if (document.visibilityState === 'visible') onAppResume();
    });

    window.addEventListener('pageshow', (e) => {
        if (e.persisted) onAppResume();
    });
});
</script>

<template>
    <TheStockStatusPage v-if="storeSettings.statusStockFuture || storeSettings.statusStockClosed" />
	<div v-else class="wrapper">
		<main class="main" :style="{ paddingBottom: storeScroll.paddingTop }">
			<RouterView />
		</main>
		<AppNav />
		<BaseLoader v-if="!storeSettings.isPageLoaded || storeRequests.isLoading" />
	</div>
	<TheModals/>
</template>

<style scoped></style>
